import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "../../presentation/hooks/store-hooks"
import {
  resetCreateClienteFormState,
  setClienteIdVincularProdutoState,
  setClientesState,
  setCreateClienteFormCnpjState,
  setCreateClienteFormErrorsState,
  setCreateClienteFormLoginState,
  setCreateClienteFormNomeFantasiaState,
  setCreateClienteFormRazaoSocialState,
  setCreateClienteFormExternalSearchState,
  setCreateClienteFormTouchedState,
  setCreateClienteFormVendedorIdState,
  setEditClienteFormIdState,
  setEditClienteFormCnpjState,
  setEditClienteFormLoginState,
  setEditClienteFormNomeFantasiaState,
  setEditClienteFormRazaoSocialState,
  setEditClienteFormStatusState,
  setEditClienteFormVendedorIdState,
  setProdutosVinculadosState,
  setVincularIPClienteFormClienteIdState,
  setVincularIPClienteFormErrorsState,
  setVincularIPClienteFormIpsState,
  setVincularIPClienteFormIpValueState,
  setVincularIPClienteFormTouchedState,
  validateCreateClienteForm,
  validateVincularIPClienteForm,
  setVendedoresState,
  resetEditClienteFormState,
  resetVincularIPClienteFormState,
  setClientesPaginationState,
  setVincularProdutoCreateClienteFormFieldsState,
  resetTipoConsumoCreateClienteFormFieldsState,
  removeTipoConsumoCreateClienteFormFieldsState,
  setVincularTipoConsumoCreateClienteFormFieldsState,
  removeProdutoCreateClienteFormFieldsState,
  setEditClienteFormVendedorNomeState,
  setEditClienteFormProdutosTipoConsumoState,
  setVincularTipoConsumoEditClienteFormFieldsState,
  setClienteListFiltrosSearchState,
  setFiltrosClientesState,
  removeTipoConsumoEditClienteFormFieldsState,
  removeProdutoEditClienteFormFieldsState,
  resetClientesState,
  setEditClienteFormPlanoState,
  setEditClienteFormFaturamentoState,
  setCreateClienteFormGerarLoteFinanceiroState,
  setEditClienteFormGerarLoteFinanceiroState,
  validateEditClienteForm,
  setEditClienteFormErrorsState,
  setEditClienteFormTouchedState
} from "../../application/states/clientes"
import { useClienteApi } from "../../infra/cliente/useClienteApi"
import { useUIService } from "../ui"
import { validateCnpj } from "../../utils/validations/cnpj"
import { buildClienteTextSearchFiltersFromTerm } from "../../utils/cliente-busca-unificada"
import { useNavigate } from "react-router-dom"
import { useNavigationService } from "../../use-cases/navigation"
import {
  IClienteTable,
  IFaturamentoConfiguracao,
  IPlanoMultiRangeRequest,
  ITipoUsuario,
  PlanosVelesTabRef,
  TipoPlano
} from "../../application/models"
import { useVendedorApi } from "../../infra/vendedor"
import { useTipoConsumoApi } from "../../infra/tipo-consumo"
import { useFaturamentoApi } from '../../infra/faturamento'
import { NotaFiscalTabRef } from "../../presentation/components"
import { useFaturamento } from "../faturamento"
import { useProdutoService } from "../produto"
import { usePlanoVelesService } from "../planos-veles"
import { useTipoConsumoService } from "../tipo-consumo"
import {
  setPlanoCliente,
  setPlanoInserido,
  setPlanoAtualizado
} from "../../application/states/planoVeles/planoVeles-slice"

export const useClientesService = () => {
  const navigate = useNavigate()
  const { navigateTo } = useNavigationService()

  const dispatch = useAppDispatch()
  const {
    createClienteForm,
    vincularIPClienteForm,
    produtoConsumoVinculados,
    clienteIdVincularProduto,
    clientes,
    clientesPagination,
    editClienteForm
  } = useAppSelector((state) => state.clientes)
  const { produtosTipoConsumo } = useAppSelector((state) => state.produto)
  const { currentUser } = useAppSelector((state) => state.user)
  const {
    validatePlanoVeles,
    savePlanoVelesTabData,
    obterPlanoPorCliente,
    normalizarPlano
  } = usePlanoVelesService()
  const { saveNotaFiscalTabData, validateNotaFiscal } = useFaturamento()
  const {
    validateProdutosForm
  } = useProdutoService()
  const {
    getProdutoTipoSConsumoPadrao,
    vincularTipoConsumoCreateClienteForm
  } = useTipoConsumoService()



  // API
  const {
    getClientesListApi,
    createClienteApi,
    updateClienteApi,
    getClienteInfoByCnpjApi,
    getIpsVinculadosByClienteIdApi,
    updateIpsVinculadosByClienteIdApi,
    getProdutoConsumoVinculadoByClienteIdApi,
    updateProdutoConsumoVinculadoByClienteIdApi
  } = useClienteApi()

  const { getProdutoClienteByIdClienteApi } = useTipoConsumoApi()

  const {
    getVendedoresByAtivoApi
  } = useVendedorApi()

  // NOVAS IMPORTAÇÕES PARA PLANOS E NOTA FISCAL

  const { obterFaturamentoConfiguracaoPorCliente } = useFaturamentoApi()

  const {
    setAlert,
    setLoading
  } = useUIService()

  const vendedores = useAppSelector((state) => state.vendedor)

  // Lists Actions

  const setVendedores = useCallback(async () => {
    try {
      setLoading({
        loading: true,
        message: 'Buscando vendedores...',
        id: 'vendedores'
      })

      if (currentUser) {
        const vendedores = await getVendedoresByAtivoApi(currentUser.IdUsuario, currentUser.IdCliente)

        dispatch(setVendedoresState({
          vendedores: vendedores
        }))
      }
    }
    catch (error: any) {
      setAlert({
        message: error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          'Erro ao buscar clientes',
        type: 'error'
      })
    }
    finally {
      setLoading({
        loading: false,
        id: 'vendedores'
      })
    }
  }, [setLoading, currentUser, getVendedoresByAtivoApi, dispatch, setAlert])

  const setClientesPaginaInicial = useCallback(async () => {
    if (currentUser) {
      try {
        const clientes = await getClientesListApi({
          IdCliente: Number(currentUser?.IdCliente) ?? 0,
          IdUsuario: Number(currentUser?.IdUsuario) ?? 0,
          page: clientesPagination.page,
          limit: clientesPagination.limit,

        })
        dispatch(setClientesState({
          clientes: clientes.clientes,
          total: clientes.clientes[0]?.TotalLinhas || 0
        }));
      } catch (error: any) {
        setAlert({
          message: error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            'Erro ao buscar clientes',
          type: 'error'
        });
      }
    }
  }, [clientesPagination.limit, clientesPagination.page, currentUser, dispatch, getClientesListApi, setAlert])

  const setClientes = useCallback(async (clienteListFiltros: {
    SearchCNPJ: string;
    SearchRazaoSocial: string;
    SearchNomeFantasia: string;
    SearchLoginCliente: string;
    SearchInclusaoMaxima: Date | undefined;
    SearchInclusaoMinima: Date | undefined;
    SearchIdUsuario: number;
    searchIdVendedor: number;
    SearchIdCliente: number;
    page?: number;
    limit?: number;
  }) => {
    const loadingId = Math.random().toString();
    setLoading({
      loading: true,
      message: 'Buscando clientes...',
      id: loadingId
    })
    try {
      dispatch(setFiltrosClientesState({
        searchIdCliente: Number(currentUser?.IdCliente),
        searchIdUsuario: Number(currentUser?.IdUsuario),
        searchCNPJ: clienteListFiltros.SearchCNPJ || '',
        searchRazaoSocial: clienteListFiltros.SearchRazaoSocial || '',
        searchNomeFantasia: clienteListFiltros.SearchNomeFantasia || '',
        searchLoginCliente: clienteListFiltros.SearchLoginCliente || '',
        searchInclusaoMaxima: clienteListFiltros.SearchInclusaoMaxima,
        searchInclusaoMinima: clienteListFiltros.SearchInclusaoMinima,
        usuario: clienteListFiltros.SearchIdUsuario || 0,
        idVendedor: clienteListFiltros.searchIdVendedor || 0,
      }))

      const requestPayload = {
        CNPJ: clienteListFiltros.SearchCNPJ,
        RazaoSocial: clienteListFiltros.SearchRazaoSocial,
        NomeFantasia: clienteListFiltros.SearchNomeFantasia,
        LoginCliente: clienteListFiltros.SearchLoginCliente,
        InclusaoMaxima: clienteListFiltros.SearchInclusaoMaxima,
        InclusaoMinima: clienteListFiltros.SearchInclusaoMinima,
        IdUsuario: Number(currentUser?.IdUsuario),
        IdCliente: Number(clienteListFiltros.SearchIdCliente),
        IdVendedor: Number(clienteListFiltros.searchIdVendedor),
        page: clienteListFiltros.page ?? clientesPagination.page,
        limit: clienteListFiltros.limit ?? clientesPagination.limit,
      };
      const clientesFilter = await getClientesListApi(requestPayload);

      if (clientesFilter) {
        const isUsuarioCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE
        const shouldUpdate = !isUsuarioCliente || clientesFilter.clientes.length > 0 || clientes.length === 0

        if (shouldUpdate) {
          dispatch(setClientesState({
            clientes: clientesFilter.clientes,
            total: clientesFilter.clientes[0]?.TotalLinhas || 0
          }))
        }
      }
    } catch (error: any) {
      setAlert({
        message: error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          'Erro ao buscar clientes',
        type: 'error'
      });
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      });
    }
  }, [currentUser, clientesPagination.limit, clientesPagination.page, dispatch, getClientesListApi, setAlert, setLoading]);

  const setClientesPagination = useCallback((data: {
    page: number,
    limit: number
  }) => {
    dispatch(setClientesPaginationState({
      page: data.page,
      limit: data.limit
    }))
  }, [dispatch])

  // Método para buscar clientes sem atualizar Redux (usado em relatórios)
  const buscarClientes = useCallback(async (filtros: {
    termoBusca?: string
    IdCliente?: number
    IdUsuario?: number
    IdVendedor?: number
    page?: number
    limit?: number
  }): Promise<IClienteTable[]> => {
    try {
      const search = buildClienteTextSearchFiltersFromTerm(filtros.termoBusca ?? '')
      const resultado = await getClientesListApi({
        IdCliente: filtros.IdCliente || 0,
        IdUsuario: filtros.IdUsuario || 0,
        IdVendedor: filtros.IdVendedor || 0,
        RazaoSocial: search.SearchRazaoSocial,
        NomeFantasia: search.SearchNomeFantasia,
        LoginCliente: search.SearchLoginCliente,
        CNPJ: search.SearchCNPJ,
        page: filtros.page || 1,
        limit: filtros.limit || 50
      })

      return resultado?.clientes || []
    } catch (error: any) {
      // Não usar setAlert aqui para evitar poluir a UI com erros de busca
      return []
    }
  }, [getClientesListApi])

  const setClientesClearFilters = useCallback(async (clienteListFiltros: {
    SearchCNPJ: string;
    SearchRazaoSocial: string;
    SearchNomeFantasia: string;
    SearchLoginCliente: string;
    SearchInclusaoMaxima: Date | undefined;
    SearchInclusaoMinima: Date | undefined;
    SearchIdUsuario: number;
    SearchIdVendedor: number;
    SearchIdCliente: number;
  }) => {
    const loadingId = Math.random().toString();
    setLoading({
      loading: true,
      message: 'Buscando clientes...',
      id: loadingId
    })
    try {
      dispatch(setClienteListFiltrosSearchState({
        SearchIdCliente: Number(currentUser?.IdCliente),
        SearchIdUsuario: Number(currentUser?.IdUsuario),
        SearchCNPJ: '',
        SearchRazaoSocial: '',
        SearchNomeFantasia: '',
        SearchLoginCliente: '',
        SearchInclusaoMaxima: undefined,
        SearchInclusaoMinima: undefined,
        SearchIdVendedor: 0
      }))
    } catch (error: any) {
      setAlert({
        message: error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          'Erro ao buscar clientes',
        type: 'error'
      });
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      });
    }
  }, [currentUser?.IdCliente, currentUser?.IdUsuario, dispatch, setAlert, setLoading])


  // Vincular Produto Actions
  const setClientesOpenVincularProduto = useCallback(async (data: {
    open: boolean,
    clienteId?: string
  }) => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Buscando produtos vinculados...',
      id: loadingId
    })
    try {
      if (data.open) {
        if (data.clienteId) {
          const produtosVinculados = await getProdutoConsumoVinculadoByClienteIdApi(data.clienteId)
          dispatch(setProdutosVinculadosState({
            produtos: produtosVinculados
          }))
          dispatch(setClienteIdVincularProdutoState({
            clienteId: data.clienteId
          }))
          navigate('/dashboard/cadastro/cliente/edit/vincular-produto')
        }
      } else {
        dispatch(setProdutosVinculadosState({
          produtos: []
        }))
        dispatch(setClienteIdVincularProdutoState({
          clienteId: ''
        }))
        navigate('/dashboard/cadastro/cliente')
      }
    } catch (err) {

    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }

  }, [dispatch, getProdutoConsumoVinculadoByClienteIdApi, navigate, setLoading])

  const toggleProdutoVinculado = useCallback((data: {
    produtoId: string,
  }) => {
    dispatch(setProdutosVinculadosState({
      produtos: produtoConsumoVinculados.map((item) => {
        if (item.produtoId === data.produtoId) {
          return {
            ...item,
            status: !item.status
          }
        }
        return item
      })
    }))
  }, [dispatch, produtoConsumoVinculados])

  const toggleProdutoConsumoVinculado = useCallback((data: {
    produtoId: string,
    consumoId: string
  }) => {
    dispatch(setProdutosVinculadosState({
      produtos: produtoConsumoVinculados.map((item) => {
        if (item.produtoId === data.produtoId) {
          return {
            ...item,
            consumos: item.consumos.map((consumo) => {
              if (consumo.tipoConsumoId === data.consumoId) {
                return {
                  ...consumo,
                  status: !consumo.status
                }
              }
              return consumo
            })
          }
        }
        return item
      })
    }))
  }, [dispatch, produtoConsumoVinculados])

  const setProdutoVinculadoLimit = useCallback((data: {
    produtoId: string,
    limit: number
  }) => {
    dispatch(setProdutosVinculadosState({
      produtos: produtoConsumoVinculados.map((item) => {
        if (item.produtoId === data.produtoId) {
          return {
            ...item,
            limit: data.limit
          }
        }
        return item
      })
    }))
  }, [dispatch, produtoConsumoVinculados])

  const updateProdutoConsumoVinculado = useCallback(async () => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Vinculando produtos',
      id: loadingId
    })
    try {
      if (clienteIdVincularProduto && clienteIdVincularProduto !== '') {
        await updateProdutoConsumoVinculadoByClienteIdApi({
          clienteId: clienteIdVincularProduto,
          produtos: produtoConsumoVinculados
        })
        setAlert({
          message: 'Produtos vinculados com sucesso',
          type: 'success'
        })
        setClientesOpenVincularProduto({
          open: false
        })
        setProdutosVinculadosState({
          produtos: []
        })
      }
    } catch (err) {
      setAlert({
        message: 'Erro ao vincular produtos',
        type: 'error'
      })
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }
  }, [clienteIdVincularProduto, produtoConsumoVinculados, setAlert, setClientesOpenVincularProduto, setLoading, updateProdutoConsumoVinculadoByClienteIdApi])

  // Vincular IP Actions
  const setClientesVincularIp = useCallback(async (data: {
    open: boolean,
    clienteId?: string
  }) => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Buscando IPs vinculados...',
      id: loadingId
    })
    try {
      if (data.open) {
        if (data.clienteId) {
          const response = await getIpsVinculadosByClienteIdApi(data.clienteId)
          dispatch(setVincularIPClienteFormIpsState({
            ips: response
          }))
          dispatch(setVincularIPClienteFormClienteIdState({
            clienteId: data.clienteId
          }))
        }
        navigate('/dashboard/cadastro/cliente/edit/vincular-ip')
      } else {
        dispatch(setVincularIPClienteFormIpsState({
          ips: []
        }))
        dispatch(setVincularIPClienteFormClienteIdState({
          clienteId: ''
        }))
        dispatch(resetVincularIPClienteFormState())
        navigate('/dashboard/cadastro/cliente')
      }

    } catch (err) {

    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }
  }, [dispatch, getIpsVinculadosByClienteIdApi, navigate, setLoading])

  const setVincularIpClienteFormIpValue = useCallback((ip: string) => {
    dispatch(setVincularIPClienteFormIpValueState({
      ipValue: ip
    }))
  }, [dispatch])

  const setAddVincularIpClienteFormIp = useCallback(() => {
    const errors = validateVincularIPClienteForm(vincularIPClienteForm.fields)
    if (vincularIPClienteForm.fields.ips.includes(vincularIPClienteForm?.fields?.ipValue ?? '')) {
      errors.push({
        key: 'ipValue',
        message: 'IP já vinculado'
      })
    }
    if (errors.length > 0) {
      dispatch(setVincularIPClienteFormErrorsState({
        errors: errors
      }))
      dispatch(setVincularIPClienteFormTouchedState({
        touched: true
      }))
    } else {
      if (vincularIPClienteForm.fields.ipValue) {
        dispatch(setVincularIPClienteFormIpsState({
          ips: [
            ...vincularIPClienteForm.fields.ips,
            vincularIPClienteForm.fields.ipValue
          ]
        }))
      }
      dispatch(setVincularIPClienteFormIpValueState({
        ipValue: ''
      }))
      dispatch(setVincularIPClienteFormTouchedState({
        touched: false
      }))
      dispatch(setVincularIPClienteFormErrorsState({
        errors: []
      }))
    }
  }, [dispatch, vincularIPClienteForm.fields])

  const setRemoveVincularIpClienteFormIp = useCallback((ip: string) => {
    dispatch(setVincularIPClienteFormIpsState({
      ips: vincularIPClienteForm.fields.ips.filter((item) => item !== ip)
    }))
  }, [dispatch, vincularIPClienteForm.fields.ips])


  const vincularIps = useCallback(async () => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Vinculando IPs',
      id: loadingId
    })

    try {
      await updateIpsVinculadosByClienteIdApi({
        id: vincularIPClienteForm.fields.clienteId,
        ips: vincularIPClienteForm.fields.ips
      })
      setAlert({
        message: 'IPs vinculados com sucesso',
        type: 'success'
      })
      setClientesVincularIp({
        open: false
      })
    } catch (err) {
      setAlert({
        message: 'Erro ao vincular IPs',
        type: 'error'
      })
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }

  }, [setAlert, setClientesVincularIp, setLoading, updateIpsVinculadosByClienteIdApi, vincularIPClienteForm.fields.clienteId, vincularIPClienteForm.fields.ips])

  // Create Cliente Actions
  const setCreateClientesOpenForm = useCallback((openForm: boolean) => {
    if (!openForm) {
      dispatch(resetCreateClienteFormState())
      navigateTo({
        route: '/dashboard/cadastro/cliente'
      })
    } else {
      navigate('/dashboard/cadastro/cliente/create')
    }
  }, [dispatch, navigate, navigateTo])

  const initializeCreateClienteForm = useCallback(() => {
    // Limpar estados dos formulários para evitar dados residuais
    dispatch(resetEditClienteFormState())
    dispatch(resetCreateClienteFormState())
  }, [dispatch])

  const setCreateClienteFormCNPJ = useCallback((cnpj: string) => {
    dispatch(setCreateClienteFormCnpjState({
      cnpj: cnpj
    }))
  }, [dispatch])

  const setCreateClienteFormRazaoSocial = useCallback((razaoSocial: string) => {
    dispatch(setCreateClienteFormRazaoSocialState({
      razaoSocial: razaoSocial
    }))
  }, [dispatch])

  const setCreateClienteFormNomeFantasia = useCallback((nomeFantasia: string) => {
    dispatch(setCreateClienteFormNomeFantasiaState({
      nomeFantasia: nomeFantasia
    }))
  }, [dispatch])

  const setCreateClienteFormLogin = useCallback((login: string) => {
    dispatch(setCreateClienteFormLoginState({
      login: login
    }))
  }, [dispatch])

  const setCreateClienteFormVendedorId = useCallback((vendedorId: number) => {
    dispatch(setCreateClienteFormVendedorIdState({
      vendedorId: vendedorId
    }))
  }, [dispatch])

  const createCliente = useCallback(async (
    planoData?: IPlanoMultiRangeRequest,
    faturamentoData?: IFaturamentoConfiguracao
  ) => {
    // Dados do Cliente
    if (!createClienteForm.fields.cnpj?.trim()) {
      setAlert({
        message: 'Por favor, preencha o CNPJ.',
        type: 'error'
      });
      return { success: false, error: 'cnpj' };
    }

    if (!createClienteForm.fields.razaoSocial?.trim()) {
      setAlert({
        message: 'Por favor, preencha a Razão Social.',
        type: 'error'
      });
      return { success: false, error: 'razaoSocial' };
    }

    if (!createClienteForm.fields.login?.trim()) {
      setAlert({
        message: 'Por favor, preencha o Login.',
        type: 'error'
      });
      return { success: false, error: 'login' };
    }

    if (!createClienteForm.fields.idVendedor) {
      setAlert({
        message: 'Por favor, selecione um Vendedor.',
        type: 'error'
      });
      return { success: false, error: 'idVendedor' };
    }

    //Produtos 
    if (!createClienteForm.fields.ProdutosTiposConsumos || createClienteForm.fields.ProdutosTiposConsumos.length === 0) {
      setAlert({
        message: 'Por favor, selecione pelo menos um Produto/Tipo de Consumo.',
        type: 'error'
      });
      return { success: false, error: 'produtos' };
    }

    const planoVeles = planoData || createClienteForm.fields.plano;


    if (!planoVeles) {
      setAlert({
        message: 'Por favor, selecione e preencha um Plano.',
        type: 'error'
      });
      return { success: false, error: 'plano' };
    }

    if (!planoVeles.TipoPlano) {
      setAlert({
        message: 'Tipo de Plano é obrigatório.',
        type: 'error'
      });
      return { success: false, error: 'plano', field: 'tipoPlano' };
    }


    if (planoVeles.TipoPlano === TipoPlano.FeeMensal) {
      if (planoVeles.QuantidadeMinimaFee === undefined || planoVeles.QuantidadeMinimaFee === null) {
        setAlert({
          message: 'Quantidade Mínima é obrigatória no plano Fee Mensal',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'quantidadeMinimaFee' };
      }

      if (planoVeles.QuantidadeMaximaFee === undefined || planoVeles.QuantidadeMaximaFee === null) {
        setAlert({
          message: 'Quantidade Máxima é obrigatória no plano Fee Mensal',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'quantidadeMaximaFee' };
      }

      if (planoVeles.ValorFee === undefined || planoVeles.ValorFee === null) {
        setAlert({
          message: 'Valor Mensal é obrigatório no plano Fee Mensal',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'valorFee' };
      }

      if (planoVeles.ValorFee <= 0) {
        setAlert({
          message: 'Valor Mensal deve ser maior que zero',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'valorFee' };
      }

      if (planoVeles.QuantidadeMinimaFee > planoVeles.QuantidadeMaximaFee) {
        setAlert({
          message: 'Quantidade Mínima não pode ser maior que Quantidade Máxima',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'quantidadeMinimaFee' };
      }

      // Validar valor unitário do range excedente
      if (planoVeles.ValorUnitarioExcedente === undefined || planoVeles.ValorUnitarioExcedente === null) {
        setAlert({
          message: 'Valor Unitário do Excedente é obrigatório no plano Fee Mensal',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'valorUnitarioExcedente' };
      }
      if (planoVeles.ValorUnitarioExcedente <= 0) {
        setAlert({
          message: 'Valor Unitário do Excedente deve ser maior que zero',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'valorUnitarioExcedente' };
      }
    }

    //Pós Pago 
    if (planoVeles.TipoPlano === TipoPlano.PosPago) {
      if (!planoVeles.RangesPosPago || planoVeles.RangesPosPago.length === 0) {
        setAlert({
          message: 'Ranges de Pós Pago são obrigatórios',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'rangesPosPago' };
      }

      // Validar que todos os ranges tenham valor > 0
      for (let i = 0; i < planoVeles.RangesPosPago.length; i++) {
        const range = planoVeles.RangesPosPago[i];
        if (range.valor === undefined || range.valor === null || range.valor <= 0) {
          setAlert({
            message: `Valor Unitário do range ${i + 1} deve ser maior que zero`,
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'rangesPosPago' };
        }
      }
    }

    //  Pré Pago 
    if (planoVeles.TipoPlano === TipoPlano.PrePago) {
      if (!planoVeles.QuantidadeMaximaPre || planoVeles.QuantidadeMaximaPre <= 0) {
        setAlert({
          message: 'Quantidade é obrigatória no plano Pré Pago',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'quantidadePre' };
      }

      if (!planoVeles.ValorPre || planoVeles.ValorPre <= 0) {
        setAlert({
          message: 'Valor Total é obrigatório no plano Pré Pago',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'valorPre' };
      }

      if (!planoVeles.ValorUnitarioPre || planoVeles.ValorUnitarioPre <= 0) {
        setAlert({
          message: 'Valor Unitário é obrigatório no plano Pré Pago',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'valorUnitarioPre' };
      }

      if (!planoVeles.ExpiracaoPre) {
        setAlert({
          message: 'Data de Expiração é obrigatória no plano Pré Pago',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'expiracaoPre' };
      }
    }

    // POC 
    if (planoVeles.TipoPlano === TipoPlano.POC) {
      if (!planoVeles.QuantidadePOC || planoVeles.QuantidadePOC <= 0) {
        setAlert({
          message: 'Quantidade Máxima é obrigatória no plano POC',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'quantidadePOC' };
      }

      if (!planoVeles.ExpiracaoPOC) {
        setAlert({
          message: 'Data de Expiração é obrigatória no plano POC',
          type: 'error'
        });
        return { success: false, error: 'plano', field: 'expiracaoPOC' };
      }
    }

    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Criando cliente',
      id: loadingId
    })

    try {
      const errors = validateCreateClienteForm(createClienteForm.fields)
      if (errors.length > 0) {
        dispatch(setCreateClienteFormErrorsState({
          errors: errors
        }))
        dispatch(setCreateClienteFormTouchedState({
          touched: true
        }))
        return { success: false, error: 'validation', details: errors };
      }

      const faturamento = faturamentoData || createClienteForm.fields.faturamento;

      const planoNormalizado = normalizarPlano(planoVeles!);

      const vendedorSelecionado = vendedores.vendedores.find(
        v => Number(v.IdUsuario) === Number(createClienteForm.fields.idVendedor)
      );

      if (!vendedorSelecionado) {
        throw new Error('Vendedor não encontrado');
      }

      const result = await createClienteApi({
        cnpj: createClienteForm.fields.cnpj,
        login: createClienteForm.fields.login,
        nomeFantasia: createClienteForm.fields.nomeFantasia,
        razaoSocial: createClienteForm.fields.razaoSocial,
        idVendedor: createClienteForm.fields.idVendedor,
        ListaProdutosTiposConsumos: createClienteForm.fields.ProdutosTiposConsumos,
        plano: planoNormalizado,
        faturamento: faturamento || null,
        GerarLoteFinanceiro: createClienteForm.fields.GerarLoteFinanceiro ?? false
      })

      if (result && result.IdCliente) {
        dispatch(setPlanoInserido({
          dadosOriginais: planoVeles
        }))
      }

      dispatch(resetCreateClienteFormState())
      setAlert({
        message: 'Cliente criado com sucesso',
        type: 'success'
      })
      navigate('/dashboard/cadastro/cliente')
      setCreateClientesOpenForm(false)

      return { success: true };

    } catch (error: any) {
      // Tratamento especial para erro 401 (sem permissão)
      if (error?.response?.status === 401) {
        setAlert({
          message: 'Você não tem permissão para criar clientes. Apenas usuários do tipo DEMAIS podem realizar esta ação.',
          type: "error"
        })
      } else {
        setAlert({
          message: error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            'Erro ao criar cliente',
          type: "error"
        })
      }
      return { success: false, error: error.message };
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }
  }, [
    createClienteApi,
    createClienteForm.fields,
    dispatch,
    navigate,
    setAlert,
    setCreateClientesOpenForm,
    setLoading,
    vendedores.vendedores,
    normalizarPlano,
  ])

  const setCreateClienteFormInfoByCnpj = useCallback(async () => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Buscando cliente',
      id: loadingId
    })
    try {
      if (validateCnpj(createClienteForm.fields.cnpj)) {
        const clienteInfo = await getClienteInfoByCnpjApi({
          cnpj: createClienteForm.fields.cnpj
        })
        dispatch(setCreateClienteFormRazaoSocialState({
          razaoSocial: clienteInfo.razaoSocial
        }))
        dispatch(setCreateClienteFormNomeFantasiaState({
          nomeFantasia: clienteInfo.nomeFantasia
        }))
        dispatch(setCreateClienteFormExternalSearchState({
          isExternalSearch: true
        }))
        setAlert({
          message: 'Cliente encontrado',
          type: 'success'
        })
      } else {
        setAlert({
          message: 'CNPJ inválido',
          type: 'error'
        })
      }
    } catch (err: any) {
      dispatch(setCreateClienteFormExternalSearchState({
        isExternalSearch: false
      }))
      setAlert({
        message: 'CNPJ externo não encontrado',
        type: 'error'
      })
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }

  }, [createClienteForm.fields.cnpj, dispatch, getClienteInfoByCnpjApi, setAlert, setLoading])

  // Edit Cliente Actions

  const setProdutoClienteByIdCliente = useCallback(async () => {
    try {
      const idCliente = Number(editClienteForm.fields.id);

      if (!idCliente || idCliente === 0) {
        return;
      }

      const getProdutoClienteByIdCliente = await getProdutoClienteByIdClienteApi({
        IdCliente: idCliente
      });

      // Remover duplicatas de forma otimizada usando Map
      const mapaUnicos = new Map();
      getProdutoClienteByIdCliente.forEach((item: any) => {
        const chave = `${item.IdProduto}-${item.IdTipoConsumo}`;
        if (!mapaUnicos.has(chave)) {
          mapaUnicos.set(chave, { IdProduto: item.IdProduto, IdTipoConsumo: item.IdTipoConsumo });
        }
      });
      const produtosUnicos = Array.from(mapaUnicos.values());

      dispatch(setEditClienteFormProdutosTipoConsumoState({
        ProdutosTiposConsumos: produtosUnicos
      }));

    } catch (error: any) {
      setAlert({
        message: error.response?.data?.error || 'Erro ao buscar produtos do cliente',
        type: 'error'
      });
    }
  }, [dispatch, editClienteForm.fields.id, getProdutoClienteByIdClienteApi, setAlert]);


  const setEditClienteOpenForm = useCallback(async (data: {
    open: boolean,
    cliente?: IClienteTable
  }) => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Buscando dados do cliente ...',
      id: loadingId
    })

    try {
      if (data.open) {
        if (data.cliente?.IdCliente) {

          // Preencher campos básicos do cliente (síncrono - rápido)
          dispatch(setEditClienteFormIdState({
            id: String(data.cliente?.IdCliente)
          }))

          dispatch(setEditClienteFormCnpjState({
            cnpj: data.cliente?.CNPJ
          }))

          dispatch(setEditClienteFormRazaoSocialState({
            razaoSocial: data.cliente.RazaoSocial
          }))

          dispatch(setEditClienteFormNomeFantasiaState({
            nomeFantasia: data.cliente?.NomeFantasia ?? ''
          }))

          dispatch(setEditClienteFormLoginState({
            login: data.cliente?.LoginCliente
          }))

          const vendedorIdFromBackend = Number(data.cliente?.IdVendedor);

          dispatch(setEditClienteFormVendedorIdState({
            vendedorId: vendedorIdFromBackend
          }))

          dispatch(setEditClienteFormVendedorNomeState({
            LoginUsuarioVendedor: String(data.cliente?.LoginUsuarioVendedor)
          }))

          dispatch(setEditClienteFormStatusState({
            status: data.cliente?.Ativo ?? false
          }))

          dispatch(setEditClienteFormGerarLoteFinanceiroState({
            GerarLoteFinanceiro: data.cliente?.GerarLoteFinanceiro ?? false
          }))

          // ✨ OTIMIZAÇÃO: Executar todas as chamadas API em paralelo
          const [planoResult, faturamentoResult, produtosResult] = await Promise.allSettled([
            // 1. Buscar plano
            obterPlanoPorCliente(data.cliente!.IdCliente, data.cliente?.Ativo ?? false),
            // 2. Buscar faturamento
            obterFaturamentoConfiguracaoPorCliente({ IdCliente: data.cliente!.IdCliente }),
            // 3. Buscar produtos
            getProdutoClienteByIdClienteApi({ IdCliente: data.cliente!.IdCliente })
          ]);

          // Processar resultado do PLANO
          if (planoResult.status === 'fulfilled') {
            const planoData = planoResult.value;

            dispatch(setPlanoCliente({
              IdCliente: data.cliente!.IdCliente,
              planoData
            }))

            if (planoData && planoData.data?.plano?.[0]) {
              const planoApi = planoData.data.plano[0];

              const planoMapeado: IPlanoMultiRangeRequest = {
                TipoPlano: planoApi.TipoPlano,
                IdCliente: planoApi.IdCliente
              };

              if (planoApi.TipoPlano === TipoPlano.FeeMensal) {
                planoMapeado.QuantidadeMinimaFee = planoApi.FeeQuantidadeMinima || 0;
                planoMapeado.QuantidadeMaximaFee = planoApi.FeeQuantidadeMaxima || 0;
                planoMapeado.ValorFee = planoApi.FeeValorMensal;

                if (planoApi.RangesFeeExcedente && planoApi.RangesFeeExcedente.length > 0) {
                  planoMapeado.RangesFeeExcedente = planoApi.RangesFeeExcedente;
                  if (planoApi.RangesFeeExcedente[0]?.valor !== undefined) {
                    planoMapeado.ValorUnitarioExcedente = planoApi.RangesFeeExcedente[0].valor;
                  }
                }

                if (planoApi.QuantidadeMinimaExcedente !== undefined) {
                  planoMapeado.QuantidadeMinimaExcedente = planoApi.QuantidadeMinimaExcedente;
                }
                if (planoApi.ValorUnitarioExcedente !== undefined) {
                  planoMapeado.ValorUnitarioExcedente = planoApi.ValorUnitarioExcedente;
                }

              } else if (planoApi.TipoPlano === TipoPlano.PosPago) {
                if (planoApi.RangesPosPago && planoApi.RangesPosPago.length > 0) {
                  planoMapeado.RangesPosPago = planoApi.RangesPosPago;
                }
              } else if (planoApi.TipoPlano === TipoPlano.PrePago) {
                planoMapeado.QuantidadeMinimaPre = 0;
                planoMapeado.QuantidadeMaximaPre = planoApi.PreQuantidade;
                planoMapeado.ValorPre = planoApi.PreValorTotal;
                planoMapeado.ValorUnitarioPre = planoApi.PreValorUnitario;
                planoMapeado.ExpiracaoPre = planoApi.PreExpiracao ? new Date(planoApi.PreExpiracao) : undefined;

              } else if (planoApi.TipoPlano === TipoPlano.POC) {
                planoMapeado.QuantidadePOC = planoApi.POCQuantidade;
                planoMapeado.ExpiracaoPOC = planoApi.POCExpiracao ? new Date(planoApi.POCExpiracao) : undefined;
              }

              dispatch(setEditClienteFormPlanoState({ plano: planoMapeado }));
            } else {
              dispatch(setEditClienteFormPlanoState({ plano: {} as IPlanoMultiRangeRequest }));
            }
          } else {
            // Erro ao buscar plano
            if (data.cliente?.Ativo) {
              throw planoResult.reason;
            }
            dispatch(setEditClienteFormPlanoState({ plano: {} as IPlanoMultiRangeRequest }));
          }

          // Processar resultado do FATURAMENTO
          if (faturamentoResult.status === 'fulfilled') {
            const faturamentoResponse = faturamentoResult.value;
            if (faturamentoResponse) {
              dispatch(setEditClienteFormFaturamentoState({ faturamento: faturamentoResponse }))
            } else {
              dispatch(setEditClienteFormFaturamentoState({ faturamento: {} as IFaturamentoConfiguracao }))
            }
          } else {
            dispatch(setEditClienteFormFaturamentoState({ faturamento: {} as IFaturamentoConfiguracao }))
          }

          // Processar resultado dos PRODUTOS
          if (produtosResult.status === 'fulfilled') {
            const getProdutoClienteByIdCliente = produtosResult.value;

            // Remover duplicatas de forma otimizada usando Map
            const mapaUnicos = new Map();
            getProdutoClienteByIdCliente.forEach((item: any) => {
              const chave = `${item.IdProduto}-${item.IdTipoConsumo}`;
              if (!mapaUnicos.has(chave)) {
                mapaUnicos.set(chave, { IdProduto: item.IdProduto, IdTipoConsumo: item.IdTipoConsumo });
              }
            });
            const produtosUnicos = Array.from(mapaUnicos.values());

            dispatch(setEditClienteFormProdutosTipoConsumoState({
              ProdutosTiposConsumos: produtosUnicos
            }));
          } else {
            // Erro ao buscar produtos
            setAlert({
              message: produtosResult.reason?.response?.data?.error || 'Erro ao buscar produtos do cliente',
              type: 'error'
            });
            throw produtosResult.reason;
          }

          navigateTo({
            route: '/dashboard/cadastro/cliente/edit'
          })
        }
      } else {
        dispatch(resetEditClienteFormState())
        navigate('/dashboard/cadastro/cliente')
      }

    } catch (err) {
      setAlert({
        message: 'Erro ao carregar dados do cliente para edição',
        type: 'error'
      })
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }
  }, [
    dispatch,
    navigate,
    navigateTo,
    setLoading,
    obterFaturamentoConfiguracaoPorCliente,
    obterPlanoPorCliente,
    setAlert,
    getProdutoClienteByIdClienteApi,
  ])

  const setEditClienteFormCnpj = useCallback((cnpj: string) => {
    dispatch(setEditClienteFormCnpjState({
      cnpj: cnpj
    }))
  }, [dispatch])

  const setEditClienteFormRazaoSocial = useCallback((razaoSocial: string) => {
    dispatch(setEditClienteFormRazaoSocialState({
      razaoSocial: razaoSocial
    }))
  }, [dispatch])

  const setEditClienteFormNomeFantasia = useCallback((nomeFantasia: string) => {
    dispatch(setEditClienteFormNomeFantasiaState({
      nomeFantasia: nomeFantasia
    }))
  }, [dispatch])

  const setEditClienteFormLogin = useCallback((login: string) => {
    dispatch(setEditClienteFormLoginState({
      login: login
    }))
  }, [dispatch])

  const setEditClienteFormVendedorId = useCallback((vendedorId: number) => {
    dispatch(setEditClienteFormVendedorIdState({
      vendedorId: vendedorId
    }))
  }, [dispatch])

  const setEditClienteFormStatus = useCallback((status: boolean) => {
    dispatch(setEditClienteFormStatusState({
      status: status
    }))
  }, [dispatch])

  const updateCliente = useCallback(async (
    planoValidado?: IPlanoMultiRangeRequest,
    faturamentoValidado?: IFaturamentoConfiguracao | null
  ) => {


    if (!editClienteForm.fields.cnpj?.trim()) {
      setAlert({
        message: 'Por favor, preencha o CNPJ.',
        type: 'error'
      });
      return { success: false, error: 'cnpj' };
    }

    if (!editClienteForm.fields.razaoSocial?.trim()) {
      setAlert({
        message: 'Por favor, preencha a Razão Social.',
        type: 'error'
      });
      return { success: false, error: 'razaoSocial' };
    }

    if (!editClienteForm.fields.login?.trim()) {
      setAlert({
        message: 'Por favor, preencha o Login.',
        type: 'error'
      });
      return { success: false, error: 'login' };
    }

    if (!editClienteForm.fields.idVendedor) {
      setAlert({
        message: 'Por favor, selecione um Vendedor.',
        type: 'error'
      });
      return { success: false, error: 'idVendedor' };
    }

    if (editClienteForm.fields.Ativo) {
      if (!editClienteForm.fields.ProdutosTiposConsumos || editClienteForm.fields.ProdutosTiposConsumos.length === 0) {
        setAlert({
          message: 'Por favor, selecione pelo menos um Produto/Tipo de Consumo.',
          type: 'error'
        });
        return { success: false, error: 'produtos' };
      }

      if (!editClienteForm.fields.plano) {
        setAlert({
          message: 'Por favor, selecione e preencha um Plano.',
          type: 'error'
        });
        return { success: false, error: 'plano' };
      }

      if (editClienteForm.fields.plano.TipoPlano === TipoPlano.FeeMensal) {
        if (editClienteForm.fields.plano.QuantidadeMinimaFee === undefined ||
          editClienteForm.fields.plano.QuantidadeMinimaFee === null) {
          setAlert({
            message: 'Quantidade Mínima é obrigatória no plano Fee Mensal',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'quantidadeMinimaFee' };
        }

        if (editClienteForm.fields.plano.QuantidadeMaximaFee === undefined ||
          editClienteForm.fields.plano.QuantidadeMaximaFee === null) {
          setAlert({
            message: 'Quantidade Máxima é obrigatória no plano Fee Mensal',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'quantidadeMaximaFee' };
        }

        if (editClienteForm.fields.plano.ValorFee === undefined ||
          editClienteForm.fields.plano.ValorFee === null) {
          setAlert({
            message: 'Valor Mensal é obrigatório no plano Fee Mensal',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'valorFee' };
        }

        if (editClienteForm.fields.plano.ValorFee <= 0) {
          setAlert({
            message: 'Valor Mensal deve ser maior que zero',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'valorFee' };
        }

        if (editClienteForm.fields.plano.QuantidadeMinimaFee > editClienteForm.fields.plano.QuantidadeMaximaFee) {
          setAlert({
            message: 'Quantidade Mínima não pode ser maior que Quantidade Máxima',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'quantidadeMinimaFee' };
        }

        if (editClienteForm.fields.plano.ValorUnitarioExcedente === undefined ||
          editClienteForm.fields.plano.ValorUnitarioExcedente === null) {
          setAlert({
            message: 'Valor Unitário do Excedente é obrigatório no plano Fee Mensal',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'valorUnitarioExcedente' };
        }

        if (editClienteForm.fields.plano.ValorUnitarioExcedente <= 0) {
          setAlert({
            message: 'Valor Unitário do Excedente deve ser maior que zero',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'valorUnitarioExcedente' };
        }
      }

      if (editClienteForm.fields.plano.TipoPlano === TipoPlano.PosPago) {
        if (!editClienteForm.fields.plano.RangesPosPago || editClienteForm.fields.plano.RangesPosPago.length === 0) {
          setAlert({
            message: 'Ranges de Pós Pago são obrigatórios',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'rangesPosPago' };
        }

        // Validar que todos os ranges tenham valor > 0
        for (let i = 0; i < editClienteForm.fields.plano.RangesPosPago.length; i++) {
          const range = editClienteForm.fields.plano.RangesPosPago[i];
          if (range.valor === undefined || range.valor === null || range.valor <= 0) {
            setAlert({
              message: `Valor Unitário do range ${i + 1} deve ser maior que zero`,
              type: 'error'
            });
            return { success: false, error: 'plano', field: 'rangesPosPago' };
          }
        }
      }

      if (editClienteForm.fields.plano.TipoPlano === TipoPlano.PrePago) {
        if (!editClienteForm.fields.plano.QuantidadeMaximaPre ||
          editClienteForm.fields.plano.QuantidadeMaximaPre <= 0) {
          setAlert({
            message: 'Quantidade é obrigatória no plano Pré Pago',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'quantidadePre' };
        }

        if (!editClienteForm.fields.plano.ValorPre ||
          editClienteForm.fields.plano.ValorPre <= 0) {
          setAlert({
            message: 'Valor Total é obrigatório no plano Pré Pago',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'valorPre' };
        }

        if (!editClienteForm.fields.plano.ValorUnitarioPre ||
          editClienteForm.fields.plano.ValorUnitarioPre <= 0) {
          setAlert({
            message: 'Valor Unitário é obrigatório no plano Pré Pago',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'valorUnitarioPre' };
        }

        if (!editClienteForm.fields.plano.ExpiracaoPre) {
          setAlert({
            message: 'Data de Expiração é obrigatória no plano Pré Pago',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'expiracaoPre' };
        }
      }

      if (editClienteForm.fields.plano.TipoPlano === TipoPlano.POC) {
        if (!editClienteForm.fields.plano.QuantidadePOC ||
          editClienteForm.fields.plano.QuantidadePOC <= 0) {
          setAlert({
            message: 'Quantidade Máxima é obrigatória no plano POC',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'quantidadePOC' };
        }

        if (!editClienteForm.fields.plano.ExpiracaoPOC) {
          setAlert({
            message: 'Data de Expiração é obrigatória no plano POC',
            type: 'error'
          });
          return { success: false, error: 'plano', field: 'expiracaoPOC' };
        }
      }
    }

    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Atualizando cliente',
      id: loadingId
    })

    try {
      const produtosTipoConsumos = editClienteForm.fields.ProdutosTiposConsumos.map(item => ({
        IdProduto: Number(item.IdProduto),
        IdTipoConsumo: Number(item.IdTipoConsumo),
      }));

      const vendedorSelecionado = vendedores.vendedores.find(
        v => Number(v.IdUsuario) === Number(editClienteForm.fields.idVendedor)
      );

      if (!vendedorSelecionado) {
        throw new Error('Vendedor não encontrado');
      }

      const planoParaUsar = planoValidado || editClienteForm.fields.plano;

      const planoNormalizado = planoParaUsar
        ? normalizarPlano(planoParaUsar)
        : undefined;

      const faturamentoParaUsar = faturamentoValidado !== undefined
        ? faturamentoValidado
        : editClienteForm.fields.faturamento;

      const payload = {
        cliente: {
          IdCliente: editClienteForm.fields.id,
          NomeFantasia: editClienteForm.fields.nomeFantasia ?? '',
          IdVendedor: vendedorSelecionado.IdUsuario,
          RazaoSocial: editClienteForm.fields.razaoSocial,
          CNPJ: editClienteForm.fields.cnpj,
          LoginCliente: editClienteForm.fields.login,
          Ativo: editClienteForm.fields.Ativo,
          GerarLoteFinanceiro: editClienteForm.fields.GerarLoteFinanceiro ?? false
        },
        produtosTipoConsumos,
        plano: planoNormalizado,
        faturamento: faturamentoParaUsar
      };

      const result = await updateClienteApi(payload)

      if (result && editClienteForm.fields.plano) {
        dispatch(setPlanoAtualizado({
          dadosOriginais: editClienteForm.fields.plano
        }))
      }

      setAlert({
        message: 'Cliente editado com sucesso',
        type: 'success'
      })

      // Recarregar lista de clientes após edição bem-sucedida
      // Usar setTimeout para evitar conflitos com navegação e não bloquear o fluxo
      // Marcar timestamp para evitar requisições duplicadas no ListaClientes
      if (currentUser) {
        // Armazenar timestamp no sessionStorage para o ListaClientes verificar
        sessionStorage.setItem('lastClientesReload', Date.now().toString());

        setTimeout(async () => {
          try {
            const filtros = {
              SearchCNPJ: '',
              SearchRazaoSocial: '',
              SearchNomeFantasia: '',
              SearchLoginCliente: '',
              SearchInclusaoMaxima: undefined,
              SearchInclusaoMinima: undefined,
              SearchIdUsuario: currentUser.IdUsuario,
              searchIdVendedor: currentUser.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL ? currentUser.IdUsuario : 0,
              SearchIdCliente: currentUser.IdCliente
            }
            await setClientes(filtros)
          } catch (error) {
            // Ignorar erros silenciosamente ao recarregar lista
            // A lista será atualizada na próxima vez que o usuário navegar para ela
          }
        }, 300)
      }

      setEditClienteOpenForm({
        open: false
      })

      return { success: true };
    } catch (err: any) {
      // Tratamento especial para erro 401 (sem permissão)
      if (err?.response?.status === 401) {
        setAlert({
          message: 'Você não tem permissão para editar clientes. Apenas usuários do tipo DEMAIS podem realizar esta ação.',
          type: 'error'
        });
      } else if (err?.response?.data?.type === 'InvalidFieldError') {
        const message = err?.response?.data?.message
        dispatch(setEditClienteFormErrorsState({
          errors: [{ key: 'cnpj', message }]
        }))
        dispatch(setEditClienteFormTouchedState({ touched: true }))
        setAlert({ message, type: 'error' })
      } else if (err?.response?.status === 400) {
        const message =
          err?.response?.data?.error ||
          err?.response?.data?.message
        setAlert({ message, type: 'error' })
      } else {
        setAlert({
          message: err?.response?.data?.error ||
            err?.response?.data?.message ||
            err.message ||
            'Erro ao atualizar cliente',
          type: 'error'
        });
      }
      return { success: false, error: err.message };
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }
  }, [currentUser, setClientes, setLoading, editClienteForm, updateClienteApi, setAlert, setEditClienteOpenForm, dispatch, vendedores.vendedores, normalizarPlano])


  const setEditClienteFormInfoByCnpj = useCallback(async () => {
    const loadingId = Math.random().toString()
    setLoading({
      loading: true,
      message: 'Buscando cliente',
      id: loadingId
    })
    try {
      if (validateCnpj(editClienteForm.fields.cnpj)) {
        const clienteInfo = await getClienteInfoByCnpjApi({
          cnpj: editClienteForm.fields.cnpj
        })
        dispatch(setEditClienteFormRazaoSocialState({
          razaoSocial: clienteInfo.razaoSocial
        }))
        dispatch(setEditClienteFormNomeFantasiaState({
          nomeFantasia: clienteInfo.nomeFantasia
        }))
        setAlert({
          message: 'Cliente encontrado',
          type: 'success'
        })
      } else {
        setAlert({
          message: 'CNPJ inválido',
          type: 'error'
        })
      }
    } catch (err: any) {
      setAlert({
        message: 'Cliente não encontrado',
        type: 'error'
      })
    } finally {
      setLoading({
        loading: false,
        id: loadingId
      })
    }
  }, [dispatch, editClienteForm.fields.cnpj, getClienteInfoByCnpjApi, setAlert, setLoading])

  const setVincularProdutoCreateClienteFormFields = useCallback((idProduto: number) => {
    dispatch(setVincularProdutoCreateClienteFormFieldsState({ idProduto }))
  }, [dispatch])

  const removeProdutoCreateClienteFormFields = useCallback((idProduto: number) => {
    dispatch(removeProdutoCreateClienteFormFieldsState({ idProduto }))

  }, [dispatch]);

  const setVincularTipoConsumoCreateClienteFormFields = useCallback((data: { idProduto: number, idTipoConsumo: number }) => {
    if (createClienteForm.fields.ProdutosTiposConsumos.find((tipoConsumo) => tipoConsumo.IdProduto === data.idProduto)) {

      dispatch(setVincularTipoConsumoCreateClienteFormFieldsState({ idProduto: data.idProduto, idTipoConsumo: data.idTipoConsumo }))
    }
    else {
      dispatch(setVincularProdutoCreateClienteFormFieldsState({
        idProduto: data.idProduto
      }))
      dispatch(setVincularTipoConsumoCreateClienteFormFieldsState({ idProduto: data.idProduto, idTipoConsumo: data.idTipoConsumo }))
    }
  }, [createClienteForm.fields.ProdutosTiposConsumos, dispatch])

  const removeTipoConsumoCreateClienteFormFields = useCallback((data: { idProduto: number, idTipoConsumo: number }) => {
    dispatch(removeTipoConsumoCreateClienteFormFieldsState({ idProduto: data.idProduto, idTipoConsumo: data.idTipoConsumo }))

  }, [dispatch])

  const resetTipoConsumoCreateClienteFormFields = useCallback((idProduto: number) => {
    dispatch(resetTipoConsumoCreateClienteFormFieldsState({ idProduto }))
  }, [dispatch])

  // selecionar todos
  const setVincularTodosOsTipoConsumoCreateClienteFormFields = useCallback((data: {
    idProduto: number
  }) => {
    const findProduto = produtosTipoConsumo.find((produtoTipoConsumo) => produtoTipoConsumo.produto.IdProduto === data.idProduto)
    if (findProduto) {
      for (let i = 0; i < findProduto.tipoConsumo.length; i++) {
        const tipoConsumo = findProduto.tipoConsumo[i]
        setVincularTipoConsumoCreateClienteFormFields({
          idProduto: data.idProduto,
          idTipoConsumo: tipoConsumo.IdTipoConsumo
        })
      }
    }
  }, [produtosTipoConsumo, setVincularTipoConsumoCreateClienteFormFields])



  const setVincularTipoConsumoEditClienteFormFields = useCallback((data: {
    IdProduto: number
    IdTipoConsumo: number
  }) => {
    dispatch(setVincularTipoConsumoEditClienteFormFieldsState({
      idProduto: data.IdProduto,
      idTipoConsumo: data.IdTipoConsumo
    }))
  }, [dispatch])

  const removeTipoConsumoEditClienteFormFields = useCallback((data: {
    idProduto: number
    idTipoConsumo: number
  }) => {
    dispatch(removeTipoConsumoEditClienteFormFieldsState({
      idProduto: data.idProduto,
      idTipoConsumo: data.idTipoConsumo
    }))
  }, [dispatch])

  const removeProdutoEditClienteFormFields = useCallback((data: {
    idProduto: number
  }) => {
    dispatch(removeProdutoEditClienteFormFieldsState({
      idProduto: data.idProduto
    }))
  }, [dispatch])


  // Filtros
  // const setClienteListFiltrosSearchNomeFantasia = useCallback(
  //   async (searchNomeFantasia: string) => {
  //     const loadingId = Math.random().toString();

  //     setLoading({
  //       loading: true,
  //       message: 'Buscando resposta...',
  //       id: loadingId,
  //     });


  //     try {
  //       const clientesFiltrados = await getClientesListApi({
  //         IdCliente: Number(currentUser?.IdCliente) ?? 0,
  //         IdUsuario: Number(currentUser?.IdUsuario) ?? 0,
  //         CNPJ: '',
  //         RazaoSocial: '',
  //         NomeFantasia: searchNomeFantasia,
  //         LoginCliente: '',
  //         IdVendedor: 0,
  //         InclusaoMaxima: new Date(),
  //         InclusaoMinima: new Date(),
  //         clientesPagination: {
  //           page: 1,
  //           limit: 10,
  //         },
  //       })


  //       //let formattedClientes: IClienteTable[] = []

  //       // Atualize o estado ou realize outra ação com os dados retornados
  //       if (clientesFiltrados) {
  //         if (clientesFiltrados.clientes.length > 0) {


  //           dispatch(setClientesState(clientesFiltrados))
  //         }
  //       }
  //     }
  //     catch (error: any) {

  //       setAlert({
  //         message: error.response?.data?.error || 'Erro desconhecido',
  //         type: 'error',
  //       });
  //     } finally {
  //       setLoading({ loading: false, id: loadingId });
  //     }
  //   },
  //   [currentUser, dispatch, setLoading]);

  // const resetClienteListFiltrosSearchNomeFantasia = useCallback(() => {
  //   dispatch(resetClienteListFiltrosSearchNomeFantasiaState())
  // }, [dispatch])

  const saveCurrentTabData = useCallback(async (
    tabValue: number,
    planosVelesRef: React.RefObject<PlanosVelesTabRef>,
    notaFiscalRef: React.RefObject<NotaFiscalTabRef>
  ) => {
    if (tabValue === 2) {
      savePlanoVelesTabData(planosVelesRef);
    }

    if (tabValue === 3) {
      saveNotaFiscalTabData(notaFiscalRef);
    }
  }, [savePlanoVelesTabData, saveNotaFiscalTabData]);

  const handleTabChange = useCallback(async (
    currentTabValue: number,
    newTabValue: number,
    planosVelesRef: React.RefObject<PlanosVelesTabRef>,
    notaFiscalRef: React.RefObject<NotaFiscalTabRef>
  ) => {
    await saveCurrentTabData(currentTabValue, planosVelesRef, notaFiscalRef);
    return newTabValue;
  }, [saveCurrentTabData]);

  const handleCreateCliente = useCallback(async (
    event: React.FormEvent<HTMLFormElement>,
    planosVelesRef: React.RefObject<PlanosVelesTabRef>,
    notaFiscalRef: React.RefObject<NotaFiscalTabRef>,
    setTabValue: (value: number) => void,
    setCamposComErro: (errors: Set<string>) => void
  ): Promise<{ success: boolean; error?: string }> => {
    event.preventDefault();

    try {
      await savePlanoVelesTabData(planosVelesRef);
      await saveNotaFiscalTabData(notaFiscalRef);

      const erros = new Set<string>();
      if (!createClienteForm.fields.cnpj?.trim()) {
        erros.add('cnpj');
      }
      if (!createClienteForm.fields.razaoSocial?.trim()) {
        erros.add('razaoSocial');
      }
      if (!createClienteForm.fields.login?.trim()) {
        erros.add('login');
      }
      if (!createClienteForm.fields.idVendedor) {
        erros.add('idVendedor');
      }

      if (erros.size > 0) {
        setCamposComErro(erros);
        setAlert({
          message: "Preencha todos os campos obrigatórios do cliente",
          type: "error"
        });
        setTabValue(0);
        return { success: false, error: 'validation' };
      }
      setCamposComErro(new Set());

      const validacaoProdutos = validateProdutosForm();
      if (!validacaoProdutos.isValid) {
        setAlert({
          message: validacaoProdutos.errorMessage || "Selecione pelo menos um produto/tipo de consumo",
          type: "error"
        });
        setTabValue(1);
        return { success: false, error: 'produtos' };
      }

      const validacaoPlano = validatePlanoVeles(planosVelesRef);

      if (!validacaoPlano.isValid) {
        setAlert({
          message: validacaoPlano.errorMessage || "Preencha todos os campos obrigatórios do Plano Veles",
          type: "error"
        });
        setTabValue(2);
        return { success: false, error: 'plano' };
      }

      let dadosPlanoValidado = validacaoPlano.data;
      if (!dadosPlanoValidado && planosVelesRef?.current?.getPlanoData) {
        dadosPlanoValidado = planosVelesRef.current.getPlanoData() ?? null;
      }

      if (!dadosPlanoValidado) {
        setAlert({
          message: "Preencha todos os campos obrigatórios do Plano",
          type: "error"
        });
        setTabValue(2);
        return { success: false, error: 'plano' };
      }

      if (notaFiscalRef.current) {
        const dadosNotaFiscal = notaFiscalRef.current.getNotaFiscalData();
        const validacaoNotaFiscal = validateNotaFiscal(dadosNotaFiscal);

        if (!validacaoNotaFiscal.isValid) {
          setAlert({
            message: validacaoNotaFiscal.errorMessage || "Erro na validação da nota fiscal",
            type: "error"
          });
          setTabValue(5);
          return { success: false, error: 'notaFiscal' };
        }

        if (createClienteForm.fields.GerarLoteFinanceiro === true && dadosNotaFiscal?.Ativo !== true) {
          setAlert({
            message: 'Para "Faturar Omie", ative o faturamento (Nota Fiscal) na aba Nota Fiscal.',
            type: 'error'
          })
          setTabValue(5)
          return { success: false, error: 'notaFiscal' }
        }
      }

      const result = await createCliente(dadosPlanoValidado);

      if (result.success) {
        return { success: true };
      } else {
        const errorType = result.error || '';
        let targetTab = 0;

        if (errorType === 'cnpj' || errorType === 'razaoSocial' || errorType === 'login' || errorType === 'idVendedor') {
          targetTab = 0;
        } else if (errorType === 'produtos') {
          targetTab = 1;
        } else if (errorType === 'plano' || errorType.includes('Fee Mensal') || errorType.includes('FEE MENSAL') ||
          errorType.includes('Pós Pago') || errorType.includes('PÓS PAGO') ||
          errorType.includes('Pré Pago') || errorType.includes('PRÉ PAGO') ||
          errorType.includes('POC') || errorType.includes('range')) {
          targetTab = 2;
        } else if (errorType === 'notaFiscal' || errorType.includes('nota fiscal') || errorType.includes('faturamento')) {
          targetTab = 5;
        } else {
          // Tentar identificar pela mensagem se não for um tipo conhecido
          const lowerError = errorType.toLowerCase();
          if (lowerError.includes('cnpj') || lowerError.includes('razao') ||
            lowerError.includes('login') || lowerError.includes('vendedor')) {
            targetTab = 0;
          } else if (lowerError.includes('produto') || lowerError.includes('consumo')) {
            targetTab = 1;
          } else if (lowerError.includes('plano') || lowerError.includes('valor') ||
            lowerError.includes('quantidade')) {
            targetTab = 2;
          }
        }

        setTabValue(targetTab);
        return { success: false, error: result.error };
      }
    } catch (error) {
      setAlert({
        message: 'Erro ao criar cliente. Tente novamente.',
        type: 'error'
      });
      return { success: false, error: 'unknown' };
    }
  }, [
    createClienteForm.fields,
    validateProdutosForm,
    validatePlanoVeles,
    validateNotaFiscal,
    savePlanoVelesTabData,
    saveNotaFiscalTabData,
    createCliente,
    setAlert
  ]);

  const handleEditClienteSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
    planosVelesRef: React.RefObject<PlanosVelesTabRef>,
    notaFiscalRef: React.RefObject<NotaFiscalTabRef>,
    setTabValue: (value: number) => void,
    setCamposComErro: (erros: Set<string>) => void
  ): Promise<void> => {
    event.preventDefault();

    const errors = validateEditClienteForm(editClienteForm.fields)
    if (errors.length > 0) {
      dispatch(setEditClienteFormErrorsState({ errors }))
      dispatch(setEditClienteFormTouchedState({ touched: true }))
      setCamposComErro(new Set(errors.map(e => String(e.key))))
      setAlert({
        message: errors[0]?.message || 'Verifique os campos do formulário',
        type: 'error'
      })
      setTabValue(0)
      return
    }

    // ==================== VALIDAÇÃO CAMPOS OBRIGATÓRIOS BÁSICOS (TAB 0) ====================
    const erros = new Set<string>();

    if (!editClienteForm.fields.cnpj?.trim()) {
      erros.add('cnpj');
    }

    if (!editClienteForm.fields.razaoSocial?.trim()) {
      erros.add('razaoSocial');
    }

    if (!editClienteForm.fields.login?.trim()) {
      erros.add('login');
    }

    if (!editClienteForm.fields.idVendedor) {
      erros.add('idVendedor');
    }

    if (erros.size > 0) {
      setCamposComErro(erros);
      setAlert({
        message: "Preencha todos os campos obrigatórios do cliente: CNPJ, Razão Social, Login e Vendedor",
        type: "error"
      });
      setTabValue(0);
      return;
    }

    setCamposComErro(new Set());

    // ==================== VALIDAÇÃO PRODUTOS (TAB 1) ====================
    if (editClienteForm.fields.Ativo) {
      if (!editClienteForm.fields.ProdutosTiposConsumos || editClienteForm.fields.ProdutosTiposConsumos.length === 0) {
        setAlert({
          message: "É obrigatório selecionar pelo menos um produto",
          type: "error"
        });
        setTabValue(1);
        return;
      }
    }

    // ==================== VALIDAÇÃO PLANO (TAB 2) ====================
    // Só valida o plano se o cliente estiver ativo
    let dadosPlanoValidado: IPlanoMultiRangeRequest | null = null;

    if (editClienteForm.fields.Ativo) {
      const validacaoPlano = validatePlanoVeles(planosVelesRef);

      if (!validacaoPlano.isValid) {
        setAlert({
          message: validacaoPlano.errorMessage || "Preencha todos os campos obrigatórios do Plano Veles",
          type: "error"
        });
        setTabValue(2);
        return;
      }

      dadosPlanoValidado = validacaoPlano.data;

      if (dadosPlanoValidado && dadosPlanoValidado.TipoPlano) {
        dispatch(setEditClienteFormPlanoState({ plano: dadosPlanoValidado }));
      } else {
        throw new Error("Dados do plano não encontrados após validação")
      }
    } else {
      // Se cliente inativo, não precisa validar plano, mas pode ter dados do plano
      dadosPlanoValidado = null;
    }

    // Só verifica se o plano foi carregado se o cliente estiver ativo
    if (editClienteForm.fields.Ativo && !editClienteForm.fields.plano) {
      setAlert({
        message: "Erro: Dados do plano não foram carregados. Tente salvar novamente.",
        type: "error"
      });
      setTabValue(2);
      return;
    }

    // ==================== PREPARAR DADOS DE FATURAMENTO (TAB 3) ====================
    let faturamentoValidado: IFaturamentoConfiguracao | null = null;

    if (editClienteForm.fields.Ativo && notaFiscalRef.current) {
      const dadosNotaFiscal = notaFiscalRef.current.getNotaFiscalData();

      if (dadosNotaFiscal === null) {
        setAlert({
          message: "Preencha todos os campos obrigatórios da Nota Fiscal",
          type: "error"
        });
        setTabValue(5);
        return;
      }

      if (dadosNotaFiscal) {
        if (editClienteForm.fields.GerarLoteFinanceiro === true && dadosNotaFiscal.Ativo !== true) {
          setAlert({
            message: 'Para "Faturar Omie", ative o faturamento (Nota Fiscal) na aba Nota Fiscal.',
            type: 'error'
          });
          setTabValue(5);
          return;
        }

        faturamentoValidado = {
          IdFaturamentoConfiguracaoNotaFiscal: 0,
          IdCliente: Number(editClienteForm.fields.id),
          IdNotaFiscalModeloDescricao: dadosNotaFiscal.IdNotaFiscalModeloDescricao,
          NotaFiscalModeloDescricaoPersonalizado: dadosNotaFiscal.NotaFiscalModeloDescricaoPersonalizado,
          Ativo: dadosNotaFiscal.Ativo,
          DiaVencimento: dadosNotaFiscal.DiaVencimento,
          Inclusao: new Date().toISOString(),
          SimplesNacional: dadosNotaFiscal.SimplesNacional,
          Nome: dadosNotaFiscal.Nome
        };

        // Atualiza o estado Redux também (para manter consistência)
        dispatch(setEditClienteFormFaturamentoState({ faturamento: faturamentoValidado }));
      }
    }

    // ==================== TENTATIVA DE SALVAMENTO ====================
    try {
      // Passa os dados validados diretamente para updateCliente
      const resultado = await updateCliente(dadosPlanoValidado || undefined, faturamentoValidado);

      if (resultado && !resultado.success) {
        // Identificar qual tab tem o erro baseado no tipo ou mensagem
        let targetTab = 0;
        const errorMsg = resultado.error || '';

        if (resultado.error === 'cnpj' || resultado.error === 'razaoSocial' || resultado.error === 'login' || resultado.error === 'idVendedor') {
          targetTab = 0;
          setAlert({
            message: "Erro ao validar dados básicos do cliente",
            type: "error"
          });
        } else if (resultado.error === 'produtos') {
          targetTab = 1;
          setAlert({
            message: "Erro ao validar produtos",
            type: "error"
          });
        } else if (resultado.error === 'plano' || errorMsg.includes('Fee Mensal') || errorMsg.includes('FEE MENSAL') ||
          errorMsg.includes('Pós Pago') || errorMsg.includes('PÓS PAGO') ||
          errorMsg.includes('Pré Pago') || errorMsg.includes('PRÉ PAGO') ||
          errorMsg.includes('POC') || errorMsg.includes('range') || errorMsg.includes('plano')) {
          targetTab = 2;
          setAlert({
            message: resultado.error === 'plano' ? "Erro ao validar plano Veles" : errorMsg,
            type: "error"
          });
        } else if (resultado.error === 'nota-fiscal' || errorMsg.includes('nota fiscal') || errorMsg.includes('faturamento')) {
          targetTab = 5;
          setAlert({
            message: "Erro ao validar nota fiscal",
            type: "error"
          });
        } else {
          // Se não conseguir identificar, tentar pelo conteúdo da mensagem
          if (errorMsg.toLowerCase().includes('cnpj') || errorMsg.toLowerCase().includes('razao') ||
            errorMsg.toLowerCase().includes('login') || errorMsg.toLowerCase().includes('vendedor')) {
            targetTab = 0;
          } else if (errorMsg.toLowerCase().includes('produto') || errorMsg.toLowerCase().includes('consumo')) {
            targetTab = 1;
          } else if (errorMsg.toLowerCase().includes('plano') || errorMsg.toLowerCase().includes('valor') || errorMsg.toLowerCase().includes('quantidade')) {
            targetTab = 2;
          }
        }

        setTabValue(targetTab);
        return;
      }

      setTimeout(() => {
        setEditClienteOpenForm({ open: false });
      }, 1500);

    } catch (error: any) {
      setAlert({
        message: error?.message || "Erro inesperado ao atualizar cliente",
        type: "error"
      });
    }
  };

  const setCreateClienteFormGerarLoteFinanceiro = useCallback((value: boolean) => {
    dispatch(setCreateClienteFormGerarLoteFinanceiroState({ GerarLoteFinanceiro: value }))
  }, [dispatch])

  const setEditClienteFormGerarLoteFinanceiro = useCallback((value: boolean) => {
    dispatch(setEditClienteFormGerarLoteFinanceiroState({ GerarLoteFinanceiro: value }))
  }, [dispatch])

  const aplicarTiposConsumoPadrao = useCallback(async (
    hasAppliedRef: React.MutableRefObject<boolean>
  ) => {
    if (hasAppliedRef.current) return;
    if (!produtosTipoConsumo || produtosTipoConsumo.length === 0) return;
    if (createClienteForm.fields.ProdutosTiposConsumos?.length > 0) return;

    hasAppliedRef.current = true;

    const tiposConsumoPadrao = await getProdutoTipoSConsumoPadrao();

    produtosTipoConsumo.forEach((produtoTipoConsumo) => {
      if (![1, 2].includes(produtoTipoConsumo.produto.IdProduto)) return

      produtoTipoConsumo.tipoConsumo.forEach((tipoConsumo) => {
        const isPadrao = tiposConsumoPadrao.some(
          (padrao: any) => padrao.IdTipoConsumo === tipoConsumo.IdTipoConsumo
        );

        if (isPadrao) {
          vincularTipoConsumoCreateClienteForm({
            idProduto: tipoConsumo.IdProduto,
            idTipoConsumo: tipoConsumo.IdTipoConsumo
          });
        }
      })
    });
  }, [produtosTipoConsumo, createClienteForm.fields.ProdutosTiposConsumos, getProdutoTipoSConsumoPadrao, vincularTipoConsumoCreateClienteForm]);

  const resetClientesList = useCallback(() => {
    dispatch(resetClientesState())
  }, [dispatch])

  return {
    // Lists Actions
    setClientes,
    resetClientesList,
    setClientesPaginaInicial,
    setVendedores,
    setClientesPagination,
    setClientesClearFilters,
    buscarClientes,
    //setClienteListFiltrosSearchNomeFantasia,
    // resetClienteListFiltrosSearchNomeFantasia,
    // Vincular Produto Actions
    setClientesOpenVincularProduto,
    toggleProdutoVinculado,
    toggleProdutoConsumoVinculado,
    updateProdutoConsumoVinculado,
    setProdutoVinculadoLimit,
    // Create Cliente Actions
    handleCreateCliente,
    saveCurrentTabData,
    handleTabChange,
    initializeCreateClienteForm,
    setCreateClientesOpenForm,
    setClientesVincularIp,
    setCreateClienteFormCNPJ,
    setCreateClienteFormRazaoSocial,
    setCreateClienteFormNomeFantasia,
    setCreateClienteFormLogin,
    setCreateClienteFormVendedorId,
    createCliente,
    setCreateClienteFormInfoByCnpj,
    setCreateClienteFormGerarLoteFinanceiro,
    // Edit Cliente Actions
    handleEditClienteSubmit,
    setEditClienteOpenForm,
    setEditClienteFormCnpj,
    setEditClienteFormRazaoSocial,
    setEditClienteFormNomeFantasia,
    setEditClienteFormLogin,
    setEditClienteFormVendedorId,
    setEditClienteFormStatus,
    setEditClienteFormInfoByCnpj,
    setProdutoClienteByIdCliente,
    setVincularTipoConsumoEditClienteFormFields,
    updateCliente,
    setEditClienteFormGerarLoteFinanceiro,
    // Vincular IP Actions
    setVincularIpClienteFormIpValue,
    setAddVincularIpClienteFormIp,
    setRemoveVincularIpClienteFormIp,
    vincularIps,
    // Vincular Produtos e Tipos de Consumo
    setVincularProdutoCreateClienteFormFields,
    removeProdutoCreateClienteFormFields,
    setVincularTipoConsumoCreateClienteFormFields,
    removeTipoConsumoCreateClienteFormFields,
    resetTipoConsumoCreateClienteFormFields,
    setVincularTodosOsTipoConsumoCreateClienteFormFields,
    removeTipoConsumoEditClienteFormFields,
    removeProdutoEditClienteFormFields,
    //fetchClientes
    aplicarTiposConsumoPadrao
  }
}

